import $ from 'jquery';

import {
	Swiper,
	Navigation,
	Pagination,
	Scrollbar,
	EffectCoverflow
} from 'swiper/swiper-bundle.esm';

import 'swiper/swiper-bundle.css';

const init = () => {
	var swiper1 = new Swiper('#home-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 1000,
		loop: true,
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
		},
		pagination: {
			el: '#home-slider .swiper-pagination',
			clickable: true,
		},
	});
	var swiper2 = new Swiper('#banners-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 1000,
		loop: true,
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
		},
		pagination: {
			el: '#banners-slider .swiper-pagination',
			clickable: true,
		},
	});


	var swiper3 = new Swiper('#product-slider', {
		slidesPerView: 1,
		spaceBetween: 15,
		navigation: {
			nextEl: '.product-nav.swiper-button-next',
			prevEl: '.product-nav.swiper-button-prev',
		},
		breakpoints: {
			420: {
				slidesPerView: 1,
			},
			580: {
				slidesPerView: 2,
			},
			767: {
				slidesPerView: 3,
				loop: true,
			},
			1200: {
				slidesPerView: 4,
				loop: false,
			},
		}
	});
	var swiper4 = new Swiper('#consigli-slider', {
		pagination: {
			el: '#consigli-slider .swiper-pagination',
		},
		navigation: {
			nextEl: '.consigli-nav.swiper-button-next',
			prevEl: '.consigli-nav.swiper-button-prev',
		},
		slidesPerView: 1,
		spaceBetween: 30,
		speed: 1000,
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				loop: true,
				autoplay: true,
			},
			992: {
				slidesPerView: 3,
				loop: false,
				autoplay: false,
			},
		}
	});
	var swiper5 = new Swiper('#loghi-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 1000,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		breakpoints: {
			580: {
				slidesPerView: 2,
			},
			767: {
				slidesPerView: 4,
				loop: true,
			},
			1200: {
				slidesPerView: 6,
				loop: false,
			},
		}
	});
	var swiper6 = new Swiper('#polaroid-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: '#polaroid-slider .swiper-button-next',
			prevEl: '#polaroid-slider .swiper-button-prev',
		},
		pagination: {
			el: '#polaroid-slider .swiper-pagination',
			clickable: true,
		},
	});

	var swiper7 = new Swiper('#simple-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: '#simple-slider .swiper-button-next',
			prevEl: '#simple-slider .swiper-button-prev',
		},
	});

	var swiper8 = new Swiper('#product-slider-2', {
		slidesPerView: 1,
		spaceBetween: 15,
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.product-nav.swiper-button-next',
			prevEl: '.product-nav.swiper-button-prev',
		},
		breakpoints: {
			420: {
				slidesPerView: 1,
			},
			580: {
				slidesPerView: 2,
			},
			767: {
				slidesPerView: 3,
				loop: true,
			},
			1200: {
				slidesPerView: 4,
				loop: false,
			},
		}
	});

	var swiper9 = new Swiper('#product-slider-3', {
		slidesPerView: 1,
		spaceBetween: 15,
		observer: true,
		observeParents: true,
		navigation: {
			nextEl: '.product-nav.swiper-button-next',
			prevEl: '.product-nav.swiper-button-prev',
		},
		breakpoints: {
			420: {
				slidesPerView: 1,
			},
			580: {
				slidesPerView: 2,
			},
			767: {
				slidesPerView: 3,
				loop: true,
			},
			1200: {
				slidesPerView: 4,
				loop: false,
			},
		}
	});

}

init();




